import { Component } from "react";
import { connect } from "react-redux";
import { openNode, fetchChildren, fetchChildrenMineLiked,
} from "../actions";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class Opened extends Component {
  componentDidMount() {
    const { dispatch, id, page, parent, root, server } = this.props;
    dispatch(openNode(parent));
    const parentId = server.parent[id];
    if (typeof id !== 'undefined' && id.indexOf("sign_up.") !== 0
      && id.indexOf("login.") !== 0 && id.indexOf("my.") !== 0) {
      let ids = siblingsIds(parentId, page, server.children[parentId], root)
      dispatch(fetchChildren(ids, parentId, page))
      if(cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null) {
        return
      }
      dispatch(fetchChildrenMineLiked(ids));
    }
  }
  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const siblingsIds = (id, page, children) => {
  if(root) {
    return children.slice(page, page + 11).join(",");
  }
  return children.slice(page, page + 10).join(",");
};

export default connect(mapStateToProps)(Opened);



// WEBPACK FOOTER //
// ./src/containers/Opened.js